import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import { ExtractProps } from 'app/utils/types';
import React, { FunctionComponent } from 'react';

interface IMarginGroup {
  inline?: boolean;
  margin?: ExtractProps<typeof FlexMarginGroup>['margin'];
}

const MarginGroup: FunctionComponent<IMarginGroup> = ({ children, inline = false, margin = '10px' }) => (
  <FlexMarginGroup vertical={!inline} margin={margin} wrap={inline}>
    {children}
  </FlexMarginGroup>
);

export default MarginGroup;
